<ng-container *ngIf="nodeId">
  <!-- Viewer -->
  <adf-alfresco-viewer
    [nodeId]="nodeId"
    [allowNavigate]="false"
    [allowRightSidebar]="false"
    [allowPrint]="false"
    [showRightSidebar]="false"
    [allowDownload]="false"
    [allowFullScreen]="false"
    [canNavigateBefore]="false"
    [canNavigateNext]="false"
    [overlayMode]="allowFullScreen"
    (showViewerChange)="onViewerVisibilityChanged()"
    [maxRetries]="30"
    class="aca-viewer-drawer"
  >
  </adf-alfresco-viewer>

  <!-- Watermark -->
  <div *ngIf="!(selection.file?.entry.allowableOperations && selection.file?.entry.allowableOperations.includes('download')) && selection.file">
    <app-watermark
      *ngIf="configWaterEnable"
      [lineOne]="lineOne"
      [lineTwo]="lineTwo"
      [maxFontSizeLineOne]="maxFontSizeLineOne"
      [maxFontSizeLineTwo]="maxFontSizeLineTwo"
      [colorLineOne]="colorLineOne"
      [colorLineTwo]="colorLineTwo"
      [opacityLineOne]="opacityLineOne"
      [opacityLineTwo]="opacityLineTwo"
      [displayLayout]="displayLayout"
      [maxColumns]="maxColumns"
      [rightTabOpen]="rightTabOpen"
      [reviewOnly]="true"
    >
    </app-watermark>
  </div>
</ng-container>
